module.exports = __webpack_public_path__ + "static/img/fpyb.ee6734e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fpyb.jpg
// module id = mnvF
// module chunks = 1